import React from "react";
import { useNavigate } from "react-router-dom";

export default function CommunityRulesDemoPage() {
  const navigate = useNavigate();

  return (
    <div style={styles.page}>
      <style>{`
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(35px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes rulePulse {
          0%,100% { transform: scale(1); box-shadow: 0 0 25px rgba(0,242,255,.30); }
          50% { transform: scale(1.06); box-shadow: 0 0 70px rgba(0,242,255,.85); }
        }

        @keyframes scanLine {
          0% { transform: translateX(-120%); opacity: 0; }
          35% { opacity: 1; }
          100% { transform: translateX(120%); opacity: 0; }
        }

        @keyframes checkPop {
          0%,100% { transform: scale(1); }
          50% { transform: scale(1.16); }
        }
      `}</style>

      <button onClick={() => navigate(-1)} style={styles.back}>
        ← Retour
      </button>

      <div style={styles.wrapper}>
        <div style={styles.iconCircle}>
          <div style={styles.icon}>⚖️</div>
        </div>

        <h1 style={styles.title}>Règles communautaires</h1>

        <p style={styles.subtitle}>
          Un cadre clair pour aider chaque utilisateur à évoluer dans une plateforme
          plus saine, respectueuse et sécurisée.
        </p>

        <div style={styles.rulesBox}>
          <div style={styles.scan}></div>

          <div style={styles.ruleLine}>✅ Respect entre utilisateurs</div>
          <div style={styles.ruleLine}>✅ Contenus encadrés</div>
          <div style={styles.ruleLine}>✅ Signalements pris en compte</div>
        </div>

        <div style={styles.cards}>
          <div style={styles.card}>
            <div style={styles.cardIcon}>🤝</div>
            <h3 style={styles.cardTitle}>Respect</h3>
            <p style={styles.cardText}>
              Les échanges doivent rester corrects et responsables.
            </p>
          </div>

          <div style={styles.card}>
            <div style={styles.cardIcon}>🧭</div>
            <h3 style={styles.cardTitle}>Cadre clair</h3>
            <p style={styles.cardText}>
              Les règles aident à comprendre ce qui est accepté ou non.
            </p>
          </div>

          <div style={styles.card}>
            <div style={styles.cardIcon}>🛡️</div>
            <h3 style={styles.cardTitle}>Protection</h3>
            <p style={styles.cardText}>
              L’objectif est de protéger la communauté et les créateurs.
            </p>
          </div>
        </div>

        <p style={styles.note}>
          Les règles communautaires accompagnent l’utilisation d’EVO-LIVE et
          peuvent évoluer pour mieux protéger les utilisateurs.
        </p>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background:
      "radial-gradient(circle at top right, rgba(0,242,255,0.22), transparent 34%), radial-gradient(circle at bottom left, rgba(0,145,255,0.18), transparent 32%), #03070d",
    color: "#fff",
    fontFamily: "Arial, sans-serif",
    padding: "32px 18px",
    overflowY: "auto",
    textAlign: "center",
  },

  back: {
    position: "fixed",
    top: 22,
    left: 22,
    zIndex: 20,
    padding: "11px 18px",
    borderRadius: 16,
    border: "1px solid rgba(0,242,255,0.45)",
    background: "rgba(0,12,20,0.9)",
    color: "#00f2ff",
    fontWeight: 900,
    cursor: "pointer",
    boxShadow: "0 0 18px rgba(0,242,255,0.25)",
  },

  wrapper: {
    maxWidth: 980,
    margin: "0 auto",
    paddingTop: 70,
    animation: "fadeUp 0.8s ease forwards",
  },

  iconCircle: {
    width: 135,
    height: 135,
    margin: "0 auto 28px",
    borderRadius: "50%",
    border: "2px solid rgba(0,242,255,0.7)",
    background: "rgba(0,242,255,0.08)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    animation: "rulePulse 2.4s infinite",
  },

  icon: {
    fontSize: 58,
  },

  title: {
    margin: "0 0 14px",
    fontSize: "clamp(38px, 5vw, 62px)",
    color: "#fff",
    fontWeight: 900,
    textShadow: "0 0 24px rgba(0,242,255,0.8)",
  },

  subtitle: {
    maxWidth: 850,
    margin: "0 auto 34px",
    color: "#9befff",
    fontSize: 21,
    lineHeight: 1.6,
  },

  rulesBox: {
    maxWidth: 760,
    margin: "0 auto 28px",
    padding: 24,
    borderRadius: 28,
    background: "rgba(0,12,20,0.82)",
    border: "1px solid rgba(0,242,255,0.35)",
    boxShadow: "0 0 35px rgba(0,242,255,0.16)",
    position: "relative",
    overflow: "hidden",
    display: "grid",
    gap: 12,
  },

  scan: {
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(110deg, transparent 20%, rgba(0,242,255,0.16) 50%, transparent 75%)",
    animation: "scanLine 3s infinite",
  },

  ruleLine: {
    position: "relative",
    zIndex: 2,
    padding: "14px 18px",
    borderRadius: 16,
    background: "rgba(0,242,255,0.08)",
    border: "1px solid rgba(0,242,255,0.25)",
    color: "#dffcff",
    fontWeight: 900,
    animation: "checkPop 2.6s infinite",
  },

  cards: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: 16,
  },

  card: {
    padding: 24,
    borderRadius: 24,
    background: "rgba(0,12,20,0.82)",
    border: "1px solid rgba(0,242,255,0.25)",
    boxShadow: "0 0 24px rgba(0,242,255,0.10)",
  },

  cardIcon: {
    fontSize: 34,
    marginBottom: 12,
  },

  cardTitle: {
    margin: "0 0 10px",
    color: "#fff",
    fontSize: 20,
    fontWeight: 900,
  },

  cardText: {
    margin: 0,
    color: "#9befff",
    fontSize: 15,
    lineHeight: 1.5,
  },

  note: {
    maxWidth: 760,
    margin: "28px auto 0",
    padding: 16,
    borderRadius: 18,
    background: "rgba(255,255,255,0.04)",
    border: "1px solid rgba(0,242,255,0.18)",
    color: "rgba(230,250,255,0.72)",
    fontSize: 14,
    lineHeight: 1.5,
  },
};
